"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBackButton = useBackButton;
function useBackButton(_) {
    // No-op
    // BackHandler is not available on web
}
//# sourceMappingURL=useBackButton.js.map